import { fromJS } from 'immutable';
import { SET_EMAIL, SET_PREFERENCE, SET_PREFERENCE_STATUS, SET_ORIGINAL_PREFERENCE_STATUS, SET_APPLICATION_TOKEN, SET_IS_LOADING, SET_IDAAS_TOKEN, SET_IDAAS_FAILURE, SET_CARD_TOKEN } from '../types';
const initialState = fromJS({
  email: '',
  preferenceChecked: '',
  preferenceStatus: null,
  // current possible status
  originalPreferenceStatus: null,
  // status received from API
  isLoading: false,
  idaasToken: null,
  applicationToken: null,
  applicationTokenExpiresIn: null,
  applicationTokenFetchedAt: null,
  isError: false,
  error: null,
  cardToken: null
});
const privacyReducer = (state, action) => {
  const currentState = state || initialState;
  switch (action.type) {
    case SET_APPLICATION_TOKEN:
      return currentState.set('applicationToken', action.payload || null);
    case SET_CARD_TOKEN:
      return currentState.set('cardToken', action.payload || null);
    case SET_IDAAS_TOKEN:
      return currentState.set('idaasToken', action.payload || null);
    case SET_IS_LOADING:
      return currentState.set('isLoading', Boolean(action.payload));
    case SET_IDAAS_FAILURE:
      return currentState.set('isError', true).set('error', action.payload).set('isLoading', false);
    case SET_EMAIL:
      return currentState.set('email', action.payload);
    case SET_PREFERENCE:
      return currentState.set('preferenceChecked', action.payload);
    case SET_PREFERENCE_STATUS:
      return currentState.set('preferenceStatus', action.payload);
    case SET_ORIGINAL_PREFERENCE_STATUS:
      return currentState.set('originalPreferenceStatus', action.payload);
    default:
      return currentState;
  }
};
export default privacyReducer;